import { empty } from "rxjs";

export interface AuditStd_DateRangeRules
{
    CustomerID: number,
    DOW1: number,
    DOW2: number,
    DOW3: number,
    DOW4: number,
    DOW5: number,
    DOWIndex1: number,
    DOWIndex2: number,
    DOWIndex3: number,
    DOWIndex4: number,
    DOWIndex5: number,
    MonApr: boolean,
    MonAug: boolean,
    MonDec: boolean,
    MonFeb: boolean,
    MonJan: boolean,
    MonJul: boolean,
    MonJun: boolean,
    MonMar: boolean,
    MonMay: boolean,
    MonNov: boolean,
    MonOct: boolean,
    MonSep: boolean
}
export function  defaultAuditStd_DateRangeRules():AuditStd_DateRangeRules{
  return {
    CustomerID: 0,
    DOW1: 1,
    DOW2: 1,
    DOW3: 1,
    DOW4: 1,
    DOW5: 1,
    DOWIndex1: 1,
    DOWIndex2: 1,
    DOWIndex3: 1,
    DOWIndex4: 1,
    DOWIndex5: 1,
    MonApr: false,
    MonAug: false,
    MonDec: false,
    MonFeb: false,
    MonJan: false,
    MonJul: false,
    MonJun: false,
    MonMar: false,
    MonMay: false,
    MonNov: false,
    MonOct: false,
    MonSep: false
  }
}
